import React, {Component} from 'react'
import PageHeaderWrapper from '../../../components/PageHeaderWrapper'
import {Card, Form, Tabs} from 'antd'
import Request from '../../../request'
import _ from 'lodash'

@Form.create()

class AllCompanyRules extends Component {
  state = {
    id: '',
    total: 0,
    activeTab: '0',
    refreshChild: false,
    predictions: [],
    predictionKeyWord: ''
  }

  apiRequest = async() => {
    let params = {
      results: 1000,
      sortField: "question",
      sortOrder: "ascend",
    };
    let response = await Request.getCompanyRules(params);
    this.setState({total: response.total, predictions: response.data})
  }
  componentWillMount() {
    
  }

  async componentDidMount() {
    await this.apiRequest();
  }

  constructor(props) {
    super(props)
  }
  render() {
    const {dispatch} = this.props
    const {
      form: {getFieldDecorator, setFieldsValue}
    } = this.props
    const {predictions, predictionKeyWord, id, total } = this.state;
    return (
      <PageHeaderWrapper title={` Company Rules: ${total} `}>
        <Card bordered={true}>
          <div className='companyRulesFaq'>
            <input type={'text'} name="search-predictions" placeholder='Search by keyword' className='search-predictions' onChange={(e) => {this.setState({predictionKeyWord: e.target.value})}} />
            <div style={{visibility: 'hidden', position: 'absolute', width: '0px', height: '0px'}}>
              <svg xmlns="http://www.w3.org/2000/svg">
                <symbol viewBox="0 0 24 24" id="expand-more">
                  <path d="M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6z"/><path d="M0 0h24v24H0z" fill="none"/>
                </symbol>
                <symbol viewBox="0 0 24 24" id="close">
                  <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/><path d="M0 0h24v24H0z" fill="none"/>
                </symbol>
              </svg>
            </div>
            {
              predictions && predictions.map((prediction, index) => {
                if(prediction.question.toLowerCase().indexOf(predictionKeyWord.toLowerCase()) !== -1 || prediction.answer.toLowerCase().indexOf(predictionKeyWord.toLowerCase()) !== -1 || !predictionKeyWord) {
                  return(<details key={index} open={index == 0 ? 'open':''}>
                    <summary>
                      {prediction.question}
                      <svg className="control-icon control-icon-expand" width="24" height="24" role="presentation"><use xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref="#expand-more" /></svg>
                      <svg className="control-icon control-icon-close" width="24" height="24" role="presentation"><use xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref="#close" /></svg>
                    </summary>
                    <p className="faq-desc" dangerouslySetInnerHTML={{__html: prediction.answer}}></p>
                  </details>)
                }
              })
            }
          </div>
        </Card>
      </PageHeaderWrapper>
    );
  }
}

export default AllCompanyRules
